import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import Modal from '../../../components/modal/modal.component';
import {StyledFooter} from '../../../components/pane/pane.style';
import Form from '../../../components/form'
import {useForm} from 'react-hook-form';
import {StyledModalContent} from '../../../components/modal/modal.style';
import {StyledButton, StyledWiteButton} from "../../../components/button/button.style";
import {disableSwipeToClose} from "../../../utils/tools/modals";
import {LogisticContainer} from "@app/reportPage/reportPage.component";
import {StyledTextarea} from "@components/form/input/textarea.style";

type SaveConfirmationHoursAlertModalProps = {
    isOpen: boolean;
    logisticContainer: LogisticContainer | null | undefined;
    onConfirm: (comment: string) => void;
    onCancel: () => void;
};

const SaveConfirmationHoursAlertModal: React.FC<SaveConfirmationHoursAlertModalProps> = (props: SaveConfirmationHoursAlertModalProps) => {

    const {t} = useTranslation();

    const [showModal, updateShowModal] = useState<boolean>(false);
    const [comment, setComment] = useState<string>('');

    const {handleSubmit} = useForm({
        mode: 'onChange'
    });

    const handleCancel = () => {
        updateShowModal(false);
        props.onCancel();
    };

    const handleSign = () => {
        updateShowModal(false);
        props.onConfirm(comment);
    };

    useEffect(() => {
        handleOpen();
    }, [props.isOpen]);

    const handleOpen = () => {
        updateShowModal(props.isOpen);
    };

    return (
        <Modal
            isOpen={showModal}
            canDismiss={disableSwipeToClose}
            onDidDismiss={() => props.onCancel()}>
            <Form.Container className="modalForm" onSubmit={handleSubmit(handleSign)}>
                <StyledModalContent>
                    <h1 className="title">{t("reportHoursAlert.confirmTitle")}</h1>
                    <div className="content">
                        <StyledTextarea className="bolded no-margin full-width"
                                     name="confirmAlertHoursComment"
                                        onChange={e => setComment(e.target.value)}
                        ></StyledTextarea>
                    </div>
                    <StyledFooter className="modal footer no-shadow">
                        <StyledWiteButton type="button" onClick={handleCancel}>{t("reportConfirmation.cancel")}</StyledWiteButton>
                        <StyledButton disabled={!comment} type="submit">{t("reportConfirmation.confirm")}</StyledButton>
                    </StyledFooter>
                </StyledModalContent>
            </Form.Container>
        </Modal>
    );
};

export default SaveConfirmationHoursAlertModal;